import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=b0d55682&scoped=true"
import script from "./configuration.vue?vue&type=script&lang=js"
export * from "./configuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d55682",
  null
  
)

export default component.exports